<template>
  <div class="content">
    <topWell />
    <div class="mainBox">
      <listNav :title="'联系我们'" :navData="[]" @checkPageInd="checkPageInd"/>
      <div id="company">
        <div class="tagleft" style="width: 20%">
          <img src="../../static/icon-lxwm.png" style="height: 80px;"/>
          <img src="../../static/line.png" class="icon-line" />
          <div class="leftTitle">联系我们</div>
        </div>
        <div class="tagright" style="width: 80%;position: relative">
          <div class="info">
              <div class="title">联系我们</div>
              <div class="tel">0311-67505869</div>
            <div class="item">
              <img src="../../static/icon_email.png">
              <div class="item-right">
                <p>办公邮箱</p>
                <p>hebcyjigl@163.com</p>
              </div>
            </div>
            <div class="item">
              <img src="../../static/icon_pos.png">
              <div class="item-right">
                <p>公司地址</p>
                <p>河北省石家庄市西三庄街19号</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottomNav />
  </div>
</template>

<script>
import topWell from "@/views/topWheel/topWheel.vue";
import bottomNav from "@/views/bottomNav/bottomNav.vue";
import listNav from "../../components/listNav.vue";
export default {
  components: {
    topWell,
    bottomNav,
    listNav
  },
  data() {
    return {
      companyInfo: {}
    };
  },
  created() {
    this.getCompanyInfo()
  },
  methods: {
    getCompanyInfo(){
      this.$api.getCompanyInfoApi().then(res=>{
        this.companyInfo = res.data
      })
    },
    checkPageInd(){

    }
  },
};
</script>
<style scoped lang="less">
.mainBox {
  font-family: "思源黑体";
  box-sizing: border-box;
  #company {
    margin: 0 auto;
    min-width: 93.75rem /* 1500/16 */;
    width: 93.75rem /* 1500/16 */;
    padding: 100px 6.5rem;
    padding-right: 5rem;
    display: flex;
    justify-content: space-between;
    .info {
      padding: 38px 40px;
      background-color: #fff;
      font-size: 20px;
      .title{
        font-weight: bold;
      }
      .tel{
        color: #333;
        margin-top: 15px;
      }
      .item{
        display: flex;
        align-items: center;
        margin-top: 40px;
        font-size: 18px;
        img{
          margin-right: 18px;
        }
      }
    }
  }
  .tagleft {
    img {
      display: block;
    }
    .icon-line {
      width: 89px;
      margin-top: 36px;
      margin-bottom: 30px;
    }
    .leftTitle {
      font-size: 35px;
      font-weight: bold;
    }
  }
}
.tagright{
  height: 448px;
  background: url("../../static/banner_map.png") no-repeat;
  background-size: 100% 448px;
  display: flex;
  justify-content: end;
  padding: 30px;
}
</style>
